import SWRVCache from './cache';
import useSWRV, { mutate } from './use-swrv';
export { mutate, SWRVCache };
export default useSWRV;
//# sourceMappingURL=index.js.map